(function (Drupal) {
  Drupal.behaviors.awardsScroll = {
    attach(context, settings) {
      const awards = document.querySelector('.block--canalview-banners');
      const contact = document.getElementById('contact-us');
      const navbar = document.querySelector('.navbar');
      const retail = document.getElementById('retail-contact');


      if (!awards || !navbar) return;

      const getNavbarHeight = () => navbar.offsetHeight;
      let lastKnownTop = null;

      const isInViewport = (el) => {
        const rect = el.getBoundingClientRect();
        return rect.top <= window.innerHeight && rect.bottom >= 0;
      };

      const updatePosition = () => {
        const navbarHeight = getNavbarHeight();
        const scrollY = window.scrollY;
        const contactInView =
          (contact && isInViewport(contact)) ||
          (retail && isInViewport(retail));

        let newTop;

        if (scrollY > navbarHeight && !contactInView) {
          newTop = `${navbarHeight}px`;
        } else {
          newTop = `-${awards.offsetHeight}px`;
        }

        // Only apply if changed to avoid transition spam
        if (newTop !== lastKnownTop) {
          awards.style.top = newTop;
          lastKnownTop = newTop;
        }
      };

      // Initial styling
      awards.style.position = 'fixed';
      awards.style.left = '0';
      awards.style.right = '0';
      awards.style.zIndex = '101';
      awards.style.transition = 'top 0.3s ease';

      // Hide off-screen initially after layout is known
      setTimeout(() => {
        awards.style.top = `-${awards.offsetHeight}px`;
        updatePosition();
      }, 0);

      window.addEventListener('scroll', updatePosition);
      window.addEventListener('resize', updatePosition);
    }
  };
})(Drupal);
